
<app-header-title>
  <span title>{{'hr.EmployeeAttachmentTypes'|translate}}</span>
</app-header-title>

<div class="publicsetting" style="padding: 0rem 3rem;">
    <dx-data-grid #grid class="dx-card wide-card" [dataSource]="allEmployeeAttachmentType" [showBorders]="false" [focusedRowEnabled]="true"
        [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true" [columnHidingEnabled]="true"
        [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false" [showBorders]="false"
        [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false" (onRowUpdating)="updateRow($event)"
        (onInitNewRow)="onInitNewRow($event)" (onEditingStart)="onEditingStart($event)">
        <dxo-editing mode="popup" [useIcons]="false" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"
            [texts]="button">
            <dxo-popup [title]="addpopup" [showTitle]="true" [width]="700" [height]="525" [hideOnOutsideClick]="true">
            </dxo-popup>
              <dxo-form labelMode="floating" labelLocation="top"></dxo-form>
            <dxo-texts [addRow]="addrowfun('hr.EmployeeAttachmentTypes')" confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
            </dxo-texts>
        </dxo-editing>
<dxo-paging  [pageSize]="10"> </dxo-paging>        <dxo-pager [visible]="true" allowedPageSizes="true" displayMode="full" [showPageSizeSelector]="true"
            [showInfo]="false" [showNavigationButtons]="true">
        </dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column dataField="nameAr" caption="{{'hr.NameAr'|translate}}">
            <dxi-validation-rule type="async" message="{{'errors.token'|translate}} !!"
                [validationCallback]="validateAsyncForAr">
            </dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="nameEn" caption="{{'hr.NameEn'|translate}}">
            <dxi-validation-rule type="async" message="{{'errors.token'|translate}} !!"
                [validationCallback]="validateAsyncForEn">
            </dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="id" caption="{{'hr.id'|translate}}" [visible]="false" [formItem]="{visible: false}">
        </dxi-column>
        <dxi-column type="buttons">
            <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
            <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>
        </dxi-column>
        <dxo-remote-operations [groupPaging]="true">
        </dxo-remote-operations>
    </dx-data-grid>
</div>
